import DSBox from '../../../design-system/DSBox';
import DSCircularProgress from '../../../design-system/DSCircularProgress';
import { DSTypography } from '../../../design-system/Typography';
import { useTheme } from '@mui/material';

const CollectionCodeLoading = () => {
  const { spacing } = useTheme();

  return (
    <DSBox
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        backgroundColor: '#FFFFFF',
        padding: spacing(3),
        textAlign: 'center',
        gap: spacing(4),
      }}
    >
      <DSCircularProgress size={60} sx={{ color: '#000000' }} />

      <DSBox
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: spacing(1),
          maxWidth: '400px',
        }}
      >
        <DSTypography variant="h3" sx={{ color: '#000000' }}>
          Generating Your Collection Codes
        </DSTypography>

        <DSTypography variant="body1" sx={{ color: '#666666' }}>
          Please wait while we prepare your collection codes...
        </DSTypography>

        <DSTypography
          variant="body2"
          sx={{ color: '#999999', marginTop: spacing(1) }}
        >
          This may take a few moments
        </DSTypography>
      </DSBox>
    </DSBox>
  );
};

export default CollectionCodeLoading;
